import axios from 'Helpers/axios-helper';

import {
  GET_WISH_LIST,
  ADD_ITEM_TO_LIST,
  REMOVE_ITEM_FROM_LIST,
  UPDATE_WISH_LIST,
} from './mutations';

const actions = {
  [GET_WISH_LIST]({ commit, state }, payload) {
    return axios
      .get(`${state.API_ENDPOINT}/${payload}`)
      .then(({ data }) => {
        commit({ type: GET_WISH_LIST, payload: data });
      })
      // eslint-disable-next-line no-console
      .catch(console.error.bind(console));
  },

  [UPDATE_WISH_LIST]({ commit, state }, payload) {
    return axios
      .get(`${state.API_ENDPOINT}/${payload}`)
      .then(({ data }) => {
        commit({ type: UPDATE_WISH_LIST, payload: data });
      })
      // eslint-disable-next-line no-console
      .catch(console.error.bind(console));
  },

  [ADD_ITEM_TO_LIST]({ state }, payload) {
    let query = `productId=${payload.productId}&quantity=1`

    if (payload.productVariantId) {
      query += `&productVariantId=${payload.productVariantId}`
    }

    return axios.post(`${state.API_ENDPOINT}/${payload.wishlistId}?${query}`, null);
  },

  [REMOVE_ITEM_FROM_LIST]({ state }, payload) {
    const productVariantIdWishlistItem = state.wishlist.find(({ ProductVariantId }) => ProductVariantId == payload.productVariantId);

    if (productVariantIdWishlistItem) {
      return axios.delete(`${state.API_ENDPOINT}/${payload.wishlistId}/${productVariantIdWishlistItem.Id}`);
    } else {
      const wishlistItem = state.wishlist.find(({ ProductId }) => ProductId == payload.productId);
      return axios.delete(`${state.API_ENDPOINT}/${payload.wishlistId}/${wishlistItem.Id}`);
    }
  },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/add-to-wishlist/actions.js